import { createApi } from 'api/common/createApi'

import config, { API_TYPES } from '../constants/app-config'

export const bvaAPI = createApi({
  baseURL: config[API_TYPES.BVA_API_URL],
})

export const matchandthriveApi = createApi({
  baseURL: config[API_TYPES.MT_API_URL],
})

export const facadeApi = createApi({
  baseURL: '/api',
})

export const userApiClient = createApi({
  baseURL: config[API_TYPES.API_BASE_URL],
})
